/**
 * Candidate Records (INEC candidate registry) role actions.
 *
 * Named `candidate_records` — the historic registry of everyone who contested — and deliberately
 * NOT `candidate*`: the platform "Candidate" (a Candidate-role user linked to an election, see
 * `actions.candidate_media.ts`) is a different thing, and the two must never share a code.
 *
 * ⚠️ NOT SEEDED; NAV INTENT ONLY. No `ActionKeys.cs` entry backs this code and api.core gates the
 * registry by ROLE instead (`[Authorize(Roles = "Super Admin")]` on every write; reads are open to
 * any signed-in user). The sidebar entry is therefore gated on the borrowed `ORGANIZATION` code
 * plus `superAdminOnly`, with this code recorded in `intendedRoleActions` — the Analyst Performance
 * precedent. The page also gates itself on Super Admin, because the route guard runs in observe
 * mode and would not stop anyone. Seed this code only when something reads it.
 */
export const ACTIONS_CANDIDATE_RECORDS = {
	CANDIDATE_RECORDS: 'candidate_records',
} as const;
